import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Typography, Grid, Paper, IconButton, Divider, Snackbar, Alert } from '@mui/material';
import { Facebook as FacebookIcon, Google as GoogleIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import logo from '../images/zodiak23.png'; // Import logo

// Styled components
const PaperStyled = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: 400,
  margin: 'auto',
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[6],
}));

const ButtonStyled = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(1.5),
}));

const SocialButton = styled(IconButton)(({ theme, color }) => ({
  borderRadius: '50%',
  backgroundColor: color === 'facebook' ? '#3b5998' : color === 'google' ? '#db4437' : theme.palette.background.default,
  color: '#fff',
  boxShadow: theme.shadows[2],
  '&:hover': {
    backgroundColor: color === 'facebook' ? '#2d4373' : color === 'google' ? '#c1351d' : theme.palette.action.hover,
  },
}));

const Copyright = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
}));

const Logo = styled('img')({
  width: '380px', // Adjust the size as needed
  height: 'auto',
  marginBottom: '16px', // Space between logo and form
});

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    // Validasi Input
    if (username.trim() === '' || password.trim() === '') {
      setSnackbarMessage('Username and password are required');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }
    if (!validateEmail(username) && username.length < 3) {
      setSnackbarMessage('Invalid email format or username is too short');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }
    if (password.length < 6) {
      setSnackbarMessage('Password must be at least 6 characters long');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    try {
      const response = await axios.post('http://localhost:8080/zodiakid_backend/api/login.php', {
        username,
        password
      });
      const result = response.data;

      // Debugging: Tampilkan hasil respons jika perlu
      console.log(result);

      if (result.status === 'success') {
        localStorage.setItem('token', result.token);
        setSnackbarMessage('Login successful');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        // Redirect atau lakukan tindakan lain setelah login berhasil
        // Contoh: window.location.href = '/dashboard'; // Ganti '/dashboard' dengan rute yang sesuai
      } else {
        setSnackbarMessage(result.message);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Login error:', error); // Debugging: Tampilkan error di konsol
      setSnackbarMessage('Login failed');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh', background: '#f5f5f5' }}>
      <PaperStyled>
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <Logo src={logo} alt="Zodiak Logo" />
          <form onSubmit={handleLogin}>
            <TextField
              label="Email or Username"
              type="text"
              fullWidth
              margin="normal"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
            />
            <ButtonStyled type="submit" variant="contained" color="primary" fullWidth>
              Login
            </ButtonStyled>
            <Typography variant="body2" align="center" sx={{ mt: 2 }}>
              <Link to="/forgot-password" style={{ textDecoration: 'none', color: '#1976d2' }}>Forgot password?</Link>
            </Typography>
            <Typography variant="body2" align="center" sx={{ mt: 1 }}>
              Don't have an account? <Link to="/register" style={{ textDecoration: 'none', color: '#1976d2' }}>Signup</Link>
            </Typography>
            <Divider sx={{ my: 3 }} />
            <Typography variant="body2" align="center" sx={{ mb: 2 }}>Or login with</Typography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item>
                <SocialButton color="facebook">
                  <FacebookIcon />
                </SocialButton>
              </Grid>
              <Grid item>
                <SocialButton color="google">
                  <GoogleIcon />
                </SocialButton>
              </Grid>
            </Grid>
          </form>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={() => setSnackbarOpen(false)}
          >
            <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Grid>
        <Copyright>
          &copy; {new Date().getFullYear()} ZodiakID. All rights reserved.
        </Copyright>
      </PaperStyled>
    </Grid>
  );
}

export default Login;
